export default __webpack_public_path__ + "static/media/img_joy_PC.76e09ef4.svg";